import { z } from 'zod';

const typeEnum = z.enum(['reservation', 'object-field', 'text']);

const displayName = z
  .string()
  .min(1, { message: 'Display name cannot be empty' })
  .optional();

const reservationSchema = z.object({
  type: typeEnum.extract(['reservation']),
  value: z.string({ message: 'Field is required' }),
  displayName,
});

const objectFieldSchema = z.object({
  type: typeEnum.extract(['object-field']),
  value: z
    .string({ message: 'Both object and field is required' })
    .regex(/^\d+-\d+$/, { message: 'Field is required' }),
  displayName,
});

const textSchema = z.object({
  type: typeEnum.extract(['text']),
  value: z.string({ message: 'Value is required' }),
  displayName,
});

export const mappedValueSchema = z.discriminatedUnion(
  'type',
  [reservationSchema, objectFieldSchema, textSchema],
  { message: 'Type is required' }
);

export const fieldSchema = mappedValueSchema.and(
  z.object({ label: z.string() }, { message: 'Invalid label' })
);

export const informationBlockSchema = mappedValueSchema.and(
  z.object({
    title: z.string().optional(),
    level: z.enum(['error', 'warning', 'info']).optional(),
  })
);
